export const localStorageKeys = {
  warehouseId: 'warehouse_id_key',
  packingStation: 'packing-station',
};

export const cacheStorageKeys = {
  billingMetadata: 'billing_metadata',
};
